import { INVOICE_LOCALISATION } from "./localisation";

export const INVOICE_CURRENCY_SYMBOL = INVOICE_LOCALISATION.currencySymbol;

export const INVOICE_PRINT_AREA_CLASS = "invoice-print-area";

export const INVOICE_NO_PRINT_CLASS = "no-print";
